import axios from 'axios'
import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'src/components/atoms/Button'
import Pill from 'src/components/atoms/Pill'
import Page from 'src/components/layouts/Page'
import InputWrap from 'src/components/molecules/InputWrap'
import { getPaymentLink } from 'src/slices/info'

import Logo from 'src/logos/Logo'
import css from './Verify.module.scss'
import { useNavigate } from 'react-router-dom'
import EmptyPage from 'src/components/molecules/EmptyPage'

export default function Bank(params) {
	const dispatch = useDispatch()
	const { permissions } = useSelector(state => state.auth)
	const { paymentLink, bankingCompleted, status } = useSelector(state => state.info)

	const handleSubmit = () => window.open(paymentLink, '_self')
	return (
		<Page>
			{permissions.read.includes('banking') ? (
				<div className={css.page}>
					<Logo
						height='60px'
						width='60px'
						hideText
					/>
					{bankingCompleted ? (
						<>
							<h1>Successfully connected Bank Account to Livecart!</h1>
							<p>
								Click 'Continue to Stripe' to be redirected to Stripe Connect
								Dashboard
							</p>
						</>
					) : (
						<>
							<h1>
								Setup a bank account so Livecart can pay you when you make sales!
							</h1>
							<p>
								We partner with Stripe to provide you with a secure method of
								payment. Click the button below in order to be taken to Stripe’s
								website to verify your identity and connect your bank account
							</p>
						</>
					)}

					<Button
						action={() => handleSubmit()}
						label='Continue to Stripe'
						color='white'
						// href='us'
					/>
				</div>
			) : (
				<EmptyPage
					title='You don’t have permission to view anything on this page'
					text='Ask your employer for access'
					iconName='fad fa-lock'
				/>
			)}
		</Page>
	)
}
